import { Message } from 'element-ui';
import * as types from '../mutation-types';
import {
  getSpecificRTData,
  addRTReceipt,
  setRTPaymentStatus,
  addRTComment,
  updateRTPaymentAmount,
  updateRTPaymentDue,
  ackPayment,
  undoRTConfirmation,
  deleteRTPaymentReceipt,
  confirmRTPaymentReceipt,
  undoConfirmRTPaymentReceipt,
  deleteReceivableTransaction,
  addNewReceivableTransaction,
} from '../../services/receivables';

const state = {
  receivableTransaction: {},
  loadingReceivable: false,
};

const getters = {
  getRTItem: state => state.receivableTransaction,
  loadingReceivable: state => state.loadingReceivable,
};

const mutations = {
  [types.SET_RT_ITEM](state, receivableTransaction) {
    state.receivableTransaction = receivableTransaction;
  },
  [types.SET_RT_PAYMENT_STATUS](state, { id, value }) {
    let paymentIndex = state.receivableTransaction.data.receivableTransactions;
    paymentIndex = paymentIndex.receivableTransactions.findIndex(item => item.id === id);
    state.receivableTransaction.data.payment.receivableTransactions[paymentIndex].paymentStatus = value;
  },
  [types.SET_RECEIVABLE_LOADING](state, status) {
    state.loadingReceivable = status;
  },
};

const actions = {
  reloadRTItem({ commit }) {
    commit(types.SET_RECEIVABLE_LOADING, true);
    getSpecificRTData(state.receivableTransaction.data.id).then(response => response)
      .then((data) => {
        commit(types.SET_RT_ITEM, data);
        commit(types.SET_RECEIVABLE_LOADING, false);
      })
      .catch(() => {
        Message.error('Something went wrong! Try again.');
      });
  },
  setRTReceipt({ commit, dispatch }, receiptInfo) {
    commit(types.SET_RECEIVABLE_LOADING, true);
    addRTReceipt(receiptInfo.rtId, receiptInfo.payment).then(response => response)
      .then(() => {
        dispatch('reloadRTItem');
        commit(types.SET_RECEIVABLE_LOADING, false);
      })
      .catch((err) => {
        if (err.response.data.nonFieldErrors) {
          Message.error(err.response.data.nonFieldErrors[0]);
        } else {
          Message.error('Something went wrong! Try again.');
        }
        commit(types.SET_RECEIVABLE_LOADING, false);
      });
  },
  setRTItem({ commit }, info) {
    if (typeof info === 'object') {
      commit(types.SET_RECEIVABLE_LOADING, true);
      const id = info.id; //eslint-disable-line
      getSpecificRTData(id).then(response => response)
        .then((data) => {
          commit(types.SET_RECEIVABLE_LOADING, false);
          commit(types.SET_RT_ITEM, data);
        })
        .catch(() => {
          Message.error('Something went wrong! Try again.');
        });
    }
  },
  payRT({ commit, dispatch }, { paymentId, date }) {
    setRTPaymentStatus({
      status: 'paid',
      paidOn: date,
      id: paymentId,
    }).then(() => {
      commit(types.SET_RT_PAYMENT_STATUS, { id: paymentId, value: 'paid' });
      dispatch('getSearchedReceivableTransactionsData');
    }).catch(() => {
      Message.error('Something went wrong! Try again.');
    });
  },
  confirmRTPayment({ dispatch }, paymentId) {
    ackPayment(paymentId)
      .then(() => {
        dispatch('reloadRTItem');
        dispatch('getSearchedReceivableTransactionsData');
      })
      .catch(() => {
      });
  },
  undoRTPayment({ commit, dispatch }, paymentId) {
    setRTPaymentStatus({
      status: 'pending',
      paidOn: '',
      id: paymentId,
    }).then(() => {
      commit(types.SET_RT_PAYMENT_STATUS, { paymentId, value: 'pending' });
      dispatch('getSearchedReceivableTransactionsData');
    }).catch(() => {
      Message.error('Something went wrong! Try again.');
    });
  },
  updateRTPaymentAmount({ commit, dispatch }, data) {
    commit(types.SET_RECEIVABLE_LOADING, true);
    updateRTPaymentAmount(data).then(() => {
      dispatch('reloadRTItem');
      dispatch('getSearchedReceivableTransactionsData');
    }).catch(() => {
      Message.error('Something went wrong! Try again.');
    });
  },
  updateRTPaymentDue({ commit, dispatch }, data) {
    commit(types.SET_RECEIVABLE_LOADING, true);
    updateRTPaymentDue(data).then(() => {
      dispatch('reloadRTItem');
      dispatch('getSearchedReceivableTransactionsData');
    }).catch(() => {
      Message.error('Something went wrong! Try again.');
    });
  },
  setRTComment({ commit }, { rtId, comment, mentions }) {
    commit(types.SET_RECEIVABLE_LOADING, true);
    addRTComment({ rtId, comment, mentions })
      .then(() => {
        getSpecificRTData(rtId).then(response => response)
          .then(data => commit(types.SET_RT_ITEM, data))
          .catch(() => {
            Message.error('Something went wrong! Try again.');
          });
        commit(types.SET_RECEIVABLE_LOADING, false);
      })
      .catch(() => {
        Message.error('Something went wrong! Try again.');
        commit(types.SET_RECEIVABLE_LOADING, false);
      });
  },
  refreshRT({ commit }, { rtId }) {
    getSpecificRTData(rtId).then(response => response)
      .then(data => commit(types.SET_RT_ITEM, data))
      .catch(() => {
        Message.error('Something went wrong! Try again.');
      });
  },
  undoRTPaymentConfirmation({ dispatch }, data) {
    undoRTConfirmation(data)
      .then(() => {
        dispatch('reloadRTItem');
        dispatch('getSearchedReceivableTransactionsData');
      })
      .catch(() => {
        Message.error('Something went wrong! Try again.');
      });
  },
  deleteRTReceipt({ dispatch }, { rtId, receiptId }) {
    deleteRTPaymentReceipt(rtId, receiptId)
      .then(() => {
        dispatch('reloadRTItem');
      })
      .catch(() => {
        Message.error('Something went wrong! Try again.');
      });
  },
  deleteRT({ dispatch }, id) {
    deleteReceivableTransaction(id)
      .then(() => {
        dispatch('reloadRTItem');
      })
      .catch(() => {
        Message.error('Something went wrong! Try again.');
      });
  },
  addNewRT({ dispatch }, { id, data }) {
    const newRT = {
      receivableTransactions: [data],
    };
    addNewReceivableTransaction(id, newRT)
      .then(() => {
        dispatch('reloadRTItem');
      })
      .catch(() => {
        Message.error('Something went wrong! Try again.');
      });
  },
  confirmRTReceipt({ dispatch }, { rtId, receiptId }) {
    confirmRTPaymentReceipt(rtId, receiptId)
      .then(() => {
        dispatch('reloadRTItem');
      })
      .catch(() => {
        Message.error('Something went wrong! Try again.');
      });
  },
  undoConfirmRTReceipt({ dispatch }, { rtId, receiptId }) {
    undoConfirmRTPaymentReceipt(rtId, receiptId)
      .then(() => {
        dispatch('reloadRTItem');
      })
      .catch(() => {
        Message.error('Something went wrong! Try again.');
      });
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};



// WEBPACK FOOTER //
// ./src/store/modules/receivable.js